import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, imgUrl } from "../lib/api";
import { SEO } from "../components/SEO";
import { SafeImg } from "../components/site/SafeImg";

export default function PublishersPage() {
  const [pubs, setPubs] = useState([]);
  useEffect(() => { api.get("/publishers").then((r) => setPubs(r.publishers)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 md:py-16" data-testid="publishers-page">
      <SEO title="Publishing Houses" path="/publishers" description="Meet the publishing houses behind India's most loved magazines." />
      <span className="eyebrow">Our Partners</span>
      <h1 className="font-display text-4xl md:text-5xl font-bold tracking-tight mt-3 text-bm-ink">Publishing Houses</h1>
      <p className="text-bm-body mt-4 max-w-2xl leading-relaxed">The people and presses behind your favourite periodicals.</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
        {pubs.map((p) => (
          <Link key={p.id} to={`/publishers/${p.slug}`} data-testid={`publisher-card-${p.slug}`}
            className="group bm-card p-8 text-center transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-card-hover">
            <SafeImg src={imgUrl(p.logo)} alt={p.name} className="w-24 h-24 mx-auto rounded-lg object-cover shadow-cover" loading="lazy" />
            <h3 className="font-display font-semibold text-xl mt-5 text-bm-ink group-hover:text-bm-terra transition-colors duration-200">{p.name}</h3>
            <p className="text-xs text-bm-muted mt-1 uppercase tracking-[0.1em] font-semibold">Est. {p.founded_year} · {p.magazine_count} titles</p>
            <p className="text-sm text-bm-body mt-3 line-clamp-3 leading-relaxed">{p.about}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
